import styled from "styled-components";

export const TermsContainer = styled.div`
  margin-top: 5%;

  @media (max-width: 1000px) {
    margin-top: 25%;
  }

  .container-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 7%;
    flex-direction: column;
    @media (max-width: 1000px) {
      width: 80%;
    }
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.02em;
      color: var(--dark);
    }

    .updated {
      margin-bottom: 5%;
    }

    .subtitle {
      font-style: normal;
      font-weight: 800;
      font-size: 25px;
      line-height: 130%;
      letter-spacing: -0.02em;
      margin-top: 5%;
      margin-bottom: 5%;
    }

    .div-links {
      margin-top: 5%;
      margin-right: auto;
      div {
        margin-bottom: 12%;
      }
      a {
        display: block;
        margin-bottom: 5%;
        text-decoration-line: underline !important;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 130%;
        letter-spacing: -0.02em;
        color: #305bf2;
      }
    }
  }
`;

export const TitleFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  margin-left: 15%;
  flex-direction: row;
  h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 800;
    font-size: 45px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: var(--dark);
    @media (max-width: 1000px) {
      font-size: 30px;
    }
  }
`;

export const TermsStyled = styled.div`
  .container {
    display: flex;
    flex-direction: row;
    align-items: top;
    justify-content: center;
    margin: 0 auto;
    width: 80%;
    margin-top: 5%;
    @media (max-width: 1000px) {
      flex-direction: column;
      margin-top: 15%;
    }

    h1 {
      @media (max-width: 1000px) {
        margin-top: 5%;
        font-size: 28px;
      }
      font-weight: 800;
      font-size: 36px;
      line-height: 130%;
      letter-spacing: -0.02em;
      color: var(--black);
    }

    p {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.02em;
    }

    h3 {
      margin-top: 4%;
      font-style: normal;
      font-weight: 700;
      font-size: 28px;
      line-height: 130%;
      letter-spacing: -0.02em;
      @media (max-width: 1000px) {
        font-size: 22px;
      }
    }

    h4 {
      margin-top: 3%;
      font-style: normal;
      font-weight: 600;
      font-size: 22px;
      line-height: 130%;
      letter-spacing: -0.02em;
      @media (max-width: 1000px) {
        font-size: 18px;
      }
    }

    h1,
    h3,
    h4,
    p {
      margin-bottom: 2%;
    }

    .menu-toggle {
      position: fixed;
      top: 100px;
      left: 20px;
      z-index: 1000;
      padding: 8px 12px;
      background-color: var(--brand-color-3);
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;

      &:hover {
        background-color: #204ac8;
      }
    }

    .list {
      width: ${(props) => (props.isMenuVisible ? "25%" : "0%")};
      transition: width 0.3s ease;

      @media (max-width: 1000px) {
        width: ${(props) => (props.isMenuVisible ? "80%" : "0%")};
        position: relative;
        top: 0;
      }
      margin: 0 auto;
      position: sticky;
      top: 150px;
      height: fit-content;

      .menu {
        list-style: none;
        a {
          cursor: pointer;
        }
        .list-item {
          margin-bottom: 12%;

          li {
            margin-top: 5%;
          }

          .sub-item {
            margin-left: 15px;
            font-size: 13px;
            margin-top: 5px;
            margin-bottom: 5px;

            a {
              font-weight: 700;
              text-decoration: none !important;
              color: var(--dark);
              cursor: pointer;

              &.active {
                color: var(--brand-color-3);
                font-weight: bold;
              }

              &:hover {
                color: var(--brand-color-3);
                text-decoration: underline !important;
              }
            }
          }
        }
      }

      .color {
        padding: 5%;
        font-weight: 600;
        background-color: #ffebcc;
      }
    }

    .term {
      margin-left: 12%;
      @media (max-width: 1000px) {
        width: 90%;
      }
      width: 75%;

      .link-styled {
        color: var(--brand-color-3);
        font-weight: 600;
      }

      .manual-image {
        width: 100%;
        max-width: 800px;
        height: auto;
        margin: 20px 0;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        display: block;
        margin-left: auto;
        margin-right: auto;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
        font-size: 16px;
        text-align: left;

        th,
        td {
          padding: 12px;
          border: 1px solid #ddd;
        }

        th {
          background-color: #f2f2f2;
          font-weight: bold;
          color: var(--dark);
        }

        tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        tr:hover {
          background-color: #f1f1f1;
        }
      }
    }
  }
`;
